import { getServiceURL } from "api/utils"
import { SERVICE_PREFIX } from "utils/constants"

const getSolisURL = getServiceURL(SERVICE_PREFIX.solis)

export const urls = {
  refreshToken: () => getSolisURL("/v1/auth/refresh-token/"),
  getUserToken: () => getSolisURL("/v1/auth/user-tokens/"),
  changePassword: () => getSolisURL("/v1/auth/change-password/"),
  generateAuthCode: () => getSolisURL("/v1/auth/codes/"),
  verifyAccessToken: () => getSolisURL("/v1/auth/access-tokens/verify/"),
  signUp: () => getSolisURL("/v1/auth/signup/"),
  socialAuth: {
    list: () => getSolisURL(`/v1/auth/social/accounts/`),
    link: () => getSolisURL(`/v1/auth/social/accounts/link/`),
    unlink: id => getSolisURL(`/v1/auth/social/accounts/${id}/`),
  },
}
